import React from "react";
import { ApiError, isErrorCode } from "../api/authApiClient";
import { constants } from "../constants";
import { useTranslation, Trans } from "react-i18next";
import { ROUTES } from "@/routes/paths";
import { Link } from "react-router-dom";

interface FormattedErrorProps {
  error: ApiError;
}

export const FormattedError = ({ error }: FormattedErrorProps) => {
  const { t } = useTranslation();
  if (isErrorCode(error)) {
    switch (error.code) {
      case constants.ERROR_CODES["WEAK_PASSWORD"]:
        return (
          <>
            {t("error.passwordStrength.tooWeak")}
            <ul className="mt-3 ml-4 list-outside list-disc">
              <li>
                <strong>{t("error.passwordStrength.symbols")}</strong>
                <div>{t("error.passwordStrength.random")}</div>
                <br />
                <div>{t("error.passwordStrength.pick")}</div>
                <div>{t("error.passwordStrength.example")}</div>
              </li>
            </ul>
          </>
        );
      case constants.ERROR_CODES["LAST_PASSWORD_ATTEMPT"]:
        return (
          <div>
            <Trans
              i18nKey="error.incorrectPassword.lastAttempt"
              components={{
                forgotLink: (
                  <Link
                    to={`/${ROUTES.PUBLIC.FORGOT_PASSWORD}`}
                    className="text-sm font-medium text-muted-foreground text-red-700 underline hover:no-underline"
                  >
                    {t("login.forgotPassword")}
                  </Link>
                ),
              }}
            />
          </div>
        );
    }
  } else {
    return error;
  }
};
